import { useState, useEffect, EmptyMentorList, CustomModal, DownArrow, UpArrow, Edit, AdminMentorListSkeleton, AddMentorModal } from "../../AdminImport";
import "./AdminMentorList.css";

const MentorList = (props) => {
  const { editMentor, setEditMentor, setEditSelectedMentor, mentorData, setMentorData, fetchMentorList, fetchUserList } = props;
  const [modalData, setModalData] = useState({
    modalShow: false,
    isModalOpen: false,
    modalType: "",
    modalTitle: "",
    modalMessage: "",
    icon: null,
  });

  const handleClickClear = () => {
    setModalData(() => ({
      isModalOpen: false,
      modalType: "",
      modalTitle: "",
      modalMessage: "",
      icon: null,
    }));
  };

  useEffect(() => {
    if (editMentor.selectedMentor.length > 0) {
      const selected = editMentor.selectedMentor[0];

      setEditSelectedMentor((prevState) => ({
        ...prevState,
        id: selected?.id || "",
        mentorName: `${selected?.firstName || ""} ${selected?.lastName || ""}`,
        email: selected?.email || "",
        designationName: selected?.designation || "",
        designationId: selected?.designationId || "",
        technologyNames: selected?.skills || [],
        permissions: selected?.userPermission && selected?.userPermission !== "Inactive" ? selected?.userPermission : "",
        isMentorActive: !!(selected?.userPermission && selected?.userPermission !== ""),
        techDropdown: false,
      }));
    }
  }, [editMentor.selectedMentor]);

  useEffect(() => {
    fetchMentorList();
  }, []);

  const handleExpand = (mentorId) => {
    if (mentorData.expandMenotr === mentorId) {
      setMentorData((prevState) => ({
        ...prevState,
        expandMenotr: 0,
      }));
    } else {
      setMentorData((prevState) => ({
        ...prevState,
        expandMenotr: mentorId,
      }));
    }
  };

  return (
    <>
      <div
        className="mentor-list-container"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <p>Graders List</p>
        {/* <button
          type="button"
          className="add-mentor-button"
          onClick={() => {
            setModalData((prevState) => ({
              ...prevState,
              modalShow : true
            }));
          }}
        >
          <Add />
          Assign Role
        </button> */}
      </div>

      {mentorData.isLoading ? (
        <div className="card mentor-card">
          <div className="card-body p-0 w-100">
            <AdminMentorListSkeleton />
            <AdminMentorListSkeleton />
            <AdminMentorListSkeleton />
            <AdminMentorListSkeleton />
            <AdminMentorListSkeleton />
            <AdminMentorListSkeleton />
            <AdminMentorListSkeleton />
            <AdminMentorListSkeleton />
          </div>
        </div>
      ) : mentorData.mentor && mentorData.mentor.length === 0 ? (
        <div className="card empty-task-state d-flex justify-content-center align-items-center">
          <div className="d-flex justify-content-center align-items-center flex-column h-100">
            <EmptyMentorList />
            <p className="fw-bold mt-3 mb-1 empty-task-text">No graders assigned yet.</p>
            <p
              className="task-link"
              onClick={() => {
                setModalData((prevState) => ({
                  ...prevState,
                  modalShow: true,
                }));
              }}
            >
              Assign Graders
            </p>
          </div>
        </div>
      ) : (
        <div className="card mentor-card dp-scroll">
          <div className="card-body p-0 w-100">
            {mentorData.mentor &&
              mentorData.mentor.map((user) => {
                const commaSeparatedPermissions = user.userPermission;
                const permArray = commaSeparatedPermissions ? commaSeparatedPermissions.split(",") : ["No Permissions"];
                if (permArray[0] === "Inactive") {
                  permArray.length = 0;
                }
                return (
                  <>
                    <div key={user.id} className="card mentor-head w-100">
                      <div onClick={() => handleExpand(user.id)} className="mentor-wrapper justify-content-between">
                        <div className="d-flex gap-2">
                          <div className="image-wrapper1">
                            <div className="cert-image-box1">
                              <div className="d-flex justify-content-center noMentor-img">
                                <span className="initials">
                                  {user.firstName
                                    .split(" ")
                                    .map((name) => name.charAt(0).toUpperCase())
                                    .join("")}
                                  {user.lastName
                                    .split(" ")
                                    .map((name) => name.charAt(0).toUpperCase())
                                    .join("")}
                                </span>
                              </div>
                              {user?.userPermission == null || user.userPermission == "Inactive" ? (
                                <>
                                  <span className="aml-permission grey">INACTIVE</span>
                                </>
                              ) : (
                                <>
                                  <span className="aml-permission teal">ACTIVE</span>
                                </>
                              )}
                            </div>
                          </div>
                          <div className="text-wrapper1">
                            <p key={user.id} className="m-0">
                              <b>
                                {user.firstName} {user.lastName}
                              </b>
                            </p>

                            <p className="m-0 pos-wrapper">{user.designation} </p>
                          </div>
                        </div>
                        <div className="arrow-wrapper1">
                          <Edit
                            className="assign-btn"
                            onClick={(e) => {
                              e.preventDefault();
                              setEditMentor((prevState) => ({
                                ...prevState,
                                editModal: true,
                                selectedMentor: mentorData.mentor.filter((men) => {
                                  return men.id === user.id;
                                }),
                              }));
                            }}
                          />
                          <span className="expand-arrow">{mentorData.expandMenotr === user.id ? <UpArrow /> : <DownArrow />}</span>
                        </div>
                      </div>
                      {mentorData.expandMenotr === user.id && (
                        <div className="row mt-2">
                          <div className="technology">
                            {/* {permArray.length === 0 ? (
                            ""
                          ) : (
                            <div>
                              <p>Permissions:</p>
                              {permArray.map((perm, permIndex) => (
                                <span key={permIndex} className="badge perm-badge">
                                  <PermissionsCheck style={{ marginBottom: "2px" }} /> {perm}
                                </span>
                              ))}
                            </div>
                          )} */}
                            <p className="tech mt-2">Skilled In:</p>
                            {user.skills.map((skill, skillIndex) => (
                              <span key={skillIndex} className="badge tech-badge">
                                {skill ? skill.toUpperCase() : ""}{" "}
                              </span>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                );
              })}
          </div>
        </div>
      )}
      <AddMentorModal
        setModalData={setModalData}
        show={modalData.modalShow}
        onHide={() => {
          setModalData((prevState) => ({
            ...prevState,
            modalShow: false,
          }));
        }}
        userList={mentorData.userList}
        fetchMentorList={fetchMentorList}
        fetchUserList={fetchUserList}
      />

      {/* {editMentor.selectedMentor && editMentor.editModal && (
        <EditMentorModal
          selectedMentor={editMentor.selectedMentor[0]}
          fetchMentorList={fetchMentorList}
          fetchUserList={fetchUserList}
          show={editMentor.editModal}
          onHide={() => {
            setEditMentor((prevState) => ({
              ...prevState,
              editModal: false,
            }));
          }}
        />
      )} */}
      {modalData.isModalOpen && (
        <CustomModal
          modalProps={{
            icon: modalData.icon,
            show: modalData.isModalOpen,
            type: modalData.modalType,
            title: modalData.modalTitle,
            message: modalData.modalMessage,
            onCancel: handleClickClear,
          }}
        />
      )}
    </>
  );
};

export default MentorList;
